import styled from "@emotion/styled";
import { Icon } from "@gumtree/ui-library";
import {
    colors,
    colorVariables,
    fontWeights,
    gutterSizes,
} from "@gumtree/ui-library/src/base/theme";

const shouldForwardProp = (p: string) => !["isSelected"].includes(p);

export const StyledSubCategories = styled.div`
    display: flex;
    flex-direction: column;
    padding-left: ${gutterSizes.xlarge};
    margin-top: 21px;
    grid-gap: ${gutterSizes.large18};
`;

export const StyledIcon = styled(Icon)`
    position: relative;
    top: -2px;
    color: ${colors.darkGrey};
    cursor: pointer;
`;

export const StyledCheckIcon = styled(StyledIcon)`
    margin-left: auto;
`;

export const StyledCategoryName = styled("a", {
    shouldForwardProp,
})<{
    isSelected: boolean;
}>`
    width: 100%;
    margin: 0;
    font-weight: ${fontWeights.lightBold};

    &:hover {
        cursor: pointer;
    }

    ${(props) => `
        color: ${props.isSelected ? colorVariables.mainSecondary : colorVariables.mainTertiary};
    `};
`;

export const StyledCategory = styled.div`
    display: flex;
`;

export const StyledAbundance = styled.span`
    margin-left: ${gutterSizes.large};
    color: ${colorVariables.textSecondary};
`;
